import type { FaireProductEntity } from "../../entity_types/product";

export const p_c69zqax92s: FaireProductEntity = {
  token: "p_c69zqax92s",
  type: "product",
  name: "PHOENIX - Statement Boot, Brocade, Frog Closures",
  brandToken: "b_mz3xxxsvnf",
  brandName: "Lemonade Shoes",
  imageUrl:
    "https://cdn.faire.com/fastly/14c293ab13dac29426045c8ccc319db8bbf5bf6cbfd631d90fd12cecb935566b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/734a1f6b270d9d7184098ecf6d36419468256ef91748d461c003effad6a91ba5.jpeg",
    "https://cdn.faire.com/fastly/043300ff0e5b006ca35d3fa46774b3860917878333b6f657a069068ec5982910.jpeg",
    "https://cdn.faire.com/fastly/6c1a76f0e567ade1dce6cc92ba90c2ea37c2555b9c517a0623f64a620db41d99.jpeg",
    "https://cdn.faire.com/fastly/0d31c2ee63524e08e0aa992be413ce22f9d6d3445cc66bac79c3a7717332e92d.jpeg",
  ],
  priceDollars: 27,
  description:
    "A statement boot with an Eastern-inspired edge, featuring a silky brocade upper, intricate dragon motifs, and decorative frog closures along the front. The pointed toe and slim stiletto heel give this knee-high silhouette a sleek, feminine finish. Available in mint green and blush pink.\nOOTD\nLet the boots do the talking with a simple mini dress or micro shorts and an oversized blazer. Add a sleek shoulder bag and minimal jewelry for a cool, fashion-forward look that keeps all eyes on the print.",
  tags: [],
  msrpDollars: 54,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-13T23:39:07.008Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
